import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';
import { IPickList } from './picklist.model';
import { picklistproducts, picklistproductsSelected } from './picklist.mock';

@Injectable({
  providedIn: 'root'
})
export class EoPickListService {
  picklistproducts$ = new BehaviorSubject<IPickList[]>([]);
  picklistproductsTarget$ = new BehaviorSubject<IPickList[]>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  getPickListSourceProducts(url: string): Observable<IPickList[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.picklistproducts$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<IPickList[]>(param);
  }

  getPickListTargetProducts(url: string): Observable<IPickList[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.picklistproductsTarget$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<IPickList[]>(param);
  }

  getPickListSourceProductsMock(): Observable<IPickList[]> {
    this.status$.next(STATUS.loading);
    const obs$ = new Observable<IPickList[]>((sub) => {
      setTimeout(() => {
        sub.next(picklistproducts);
        this.picklistproducts$.next(picklistproducts);
        this.status$.next(STATUS.success);
      }, 1000);
    });

    return obs$;
  }

  getPickListTargetProductsMock(): Observable<IPickList[]> {
    this.status$.next(STATUS.loading);
    const obs$ = new Observable<IPickList[]>((sub) => {
      setTimeout(() => {
        sub.next(picklistproductsSelected);
        this.picklistproductsTarget$.next(picklistproductsSelected);
        this.status$.next(STATUS.success);
      }, 1000);
    });

    return obs$;
  }
}
